import { Spinner } from '@/components/ui';
import { twMerge } from 'tailwind-merge';
import PropTypes from 'prop-types';

const DefaultLoading = props => {
	const {
		loading,
		children,
		spinnerClass,
		className,
		asElement: Component,
		customLoader,
		size = 40
	} = props;

	return loading ? <Component className={twMerge(!customLoader && 'flex items-center justify-center h-full', className)}>
		{
			customLoader ?
				<>{customLoader}</>
				:
				<Spinner className={twMerge('animate-loader-in', spinnerClass)} size={size} />
		}
	</Component> : children

}

const CoveredLoading = props => {
	const {
		loading,
		children,
		spinnerClass,
		className,
		asElement: Component,
		customLoader,
		size = 40
	} = props;

	return (<Component className={twMerge(loading ? 'relative' : '', className)}>
		{children}
		{loading && (<div className="absolute inset-0 rounded-[inherit] bg-white/60 dark:bg-neutral-900/60 backdrop-blur-[2px] animate-loader-in" />)}
		{loading && (<div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 animate-loader-in" >
			{
				customLoader ? customLoader : <Spinner className={spinnerClass} size={size} />
			}
		</div>
		)}

	</Component>);
}

const Loading = props => {
	const {
		loading = false,
		type = 'default',
		asElement = 'div'
	} = props;

	switch (type) {
		case 'cover':
			return (<CoveredLoading loading={loading} asElement={asElement} {...props} />);
		case 'default':
		default:
			return (<DefaultLoading loading={loading} asElement={asElement} {...props} />);
	}
};

Loading.propTypes = {
	loading: PropTypes.bool,
	spinnerClass: PropTypes.string,
	type: PropTypes.oneOf(['default', 'cover']),
	customLoader: PropTypes.node
};

export default Loading;
